import styled from 'styled-components';

import { ctrlBase, ctrlMultiline, fieldContainer, fieldLabel, fieldMessage } from '../base';

export const inputContainer = styled.div`
  ${fieldContainer}
`;

export const textarea = styled.textarea`
  ${ctrlBase}
  ${ctrlMultiline}
`;

export const label = styled.label`
  ${fieldLabel}
`;

export const message = styled.span`
  ${fieldMessage}
`;
